import type { DoctorWithAddress } from './DoctorWithAddress';

export class AvailableForBookingDoctorsFilter {
  static filter(doctors: DoctorWithAddress[]): DoctorWithAddress[] {
    return doctors.filter(
      (doctorWithAddress: DoctorWithAddress) => doctorWithAddress.isAvailableForBookings,
    );
  }
}
